import {map, size, sum} from 'lodash';
import {connect} from 'react-redux';
import {Store} from 'src/types/store';
import {
  getUserInfo,
  hideVerifiedConfirmation,
  sendVerificationEmail,
  sendVerificationSMS,
  updateContactInfoUpdatedAt,
} from 'src/redux/studentNotificationBanner/actions';
import StudentNotificationBanner from 'src/components/StudentNotificationBanner/StudentNotificationBanner';
import {verifyPhoneNumber} from 'shared/actions/verify-mobile';
import {withRouter} from 'react-router-dom';

interface StateProps {
  banners: Store['banners'];
  portfolioItems: number;
}

const mapStateToProps = (state: Store): StateProps => ({
  banners: state.banners,
  portfolioItems: sum(
    map(
      [
        state.bulkEntryCourses,
        state.multimedia,
        state.communityServiceEvents,
        state.honorAwards,
        state.collegeEvents,
        state.workExperiences,
        state.activities,
        state.collegeCourses,
      ],
      (item) => size(item)
    )
  ),
});

const mapDispatchToProps = {
  sendVerificationEmail,
  hideVerifiedConfirmation,
  sendVerificationSMS,
  getUserInfo,
  updateContactInfoUpdatedAt,
  verifyPhoneNumber,
} as const;

const ConnectedBanner = connect(mapStateToProps, mapDispatchToProps)(StudentNotificationBanner);
export default withRouter(ConnectedBanner);
